import { createBrowserHistory } from 'history';

/**
 * @deprecated 16-04-2025
 *
 * BrowserRouter ignores the history prop.
 *
 *
 * Prefer `useHistory()` for navigation.
 */
const meshHistory = createBrowserHistory();
export default meshHistory;
